import { AuthorizedService, PublicService } from '../index';

const cmsService = PublicService(`/cms`);
const service = PublicService(``);
const bookingTicketsService = AuthorizedService(`/tickets_for_booking`);

export default {
  getEventsHeaderConfig() {
    return cmsService({
      method: 'GET',
      url: '/header-config',
    });
  },
  getTermsAndConditions(params) {
    return service({
      method: 'GET',
      url: '/terms-and-conditions',
      params,
    });
  },
  getPageConfig() {
    return service({
      method: 'OPTIONS',
      url: '/event/',
    });
  },
  getEventsCategoreis() {
    return service({
      method: 'GET',
      url: '/category/',
    });
  },
  getBookingTicketsStatus(bookingId, ticketUUID) {
    return bookingTicketsService({
      url: `${bookingId}/uuid/${ticketUUID}`,
      method: 'GET',
    });
  },
  createCustomerBooking(data) {
    return service({
      url: '/booking',
      method: 'POST',
      data,
    });
  },
  // #160242: frees the seats of a pending booking ("Edit booking" in the
  // new_era theme); guarded by the booking's Ottu session id
  cancelBooking(number, sessionId) {
    return service({
      url: `/booking/${number}/cancel`,
      method: 'POST',
      data: { session_id: sessionId },
    });
  },
  getBookingConfig(eventSlug) {
    return service({
      url: '/booking',
      method: 'OPTIONS',
      params: { 'event-slug': eventSlug },
    });
  },
  uploadFile(data) {
    return service({
      method: 'POST',
      url: `booking//upload`,
      data,
    });
  },
  getPayChoices(data) {
    return service({
      url: '/pay-choices',
      method: 'POST',
      data,
    });
  },
  getTicketQtyList(data) {
    return service({
      url: '/ticket/qty-list',
      method: 'POST',
      data,
    });
  },
  getEventDetails(slug) {
    return service({
      method: 'GET',
      url: `/event/${slug}/`,
    });
  },
  getEventList(params) {
    return service({
      method: 'GET',
      url: '/event/',
      params,
    });
  },
};
